import { useMemo } from 'react';

import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';

export const useWithBillingStepWorkflow = () => {
  const { valuesStep2, totalPrice, isShippable } = useRegistrationFlowContext();

  return useMemo(() => {
    if (totalPrice > 0 || isShippable) {
      return true;
    }

    const freeTicketsAttendees =
      valuesStep2.network_events_booking?.attendees_attributes
        ?.filter(({ isFree }) => isFree)
        .map(({ firstname, lastname, email }) =>
          [firstname, lastname, email].join('').toLowerCase(),
        );

    const uniqueFreeTicketAttendees = [...new Set(freeTicketsAttendees)];

    return uniqueFreeTicketAttendees.length > 1;
  }, [totalPrice, valuesStep2, isShippable]);
};
